import type { EntryPointComponent } from 'react-relay';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';

import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { projectSettingsServicedeskLanguageRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskLanguageRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import type { Route } from '@atlassian/react-resource-router';
import ServiceDeskLanguageSupport from './ui/service-desk-language-support/index.tsx';
import { LazyProjectSettingsServiceDeskLanguageTranslations } from './ui/service-desk-language-translations/index.tsx';

const projectSettingsServicedeskLanguagePageEntryPoint = createPageEntryPoint({
	main: {
		root: JSResourceForUserVisible<EntryPointComponent<{}, {}, {}, {}>>(
			/* webpackChunkName: "async-project-settings-service-desk-language-support", jiraSpaEntry: "async-project-settings-service-desk-language-support" */ '@jira/spa-apps__project-settings-service-desk-language-support/src/ExportedDefault.tsx',
			{ entryFsSsrLiftImportToModule: false },
		),
		getPreloadProps: () => ({}),
	},
});

export const projectSettingsServicedeskLanguageRouteEntry: Route = createEntry(
	projectSettingsServicedeskLanguageRoute,
	() => ({
		group: 'project-settings-servicedesk',
		ufoName: 'service-management.languages',

		// eslint-disable-next-line no-restricted-syntax
		component: fg('nike_entrypoint_migration_batch_2') ? undefined : ServiceDeskLanguageSupport,

		entryPoint: () =>
			fg('nike_entrypoint_migration_batch_2')
				? projectSettingsServicedeskLanguagePageEntryPoint
				: undefined,
		layout: serviceProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		resources: [...getServiceDeskSettingsResources(), getConsolidationStateResource()],
		forPaint: [LazyAtlassianNavigation, LazyProjectSettingsServiceDeskLanguageTranslations],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
